import styled from 'styled-components';
import { hexToRgba } from '../../utils/common';

export const HeaderContainer = styled.div`
  width: 100%;
  background: ${(props) => props?.themeConfig?.backgroundColor || '#fff'};
  border-bottom: 1px solid
    ${(props) => hexToRgba(`${props?.themeConfig?.borderColor}`, 0.1)};
`;
